// Ported from dev-scrips-pm-react src/billing/components/invoice-pending-orders-total.tsx (PROD-3312 appointment Billing
// tab, step 6). Unchanged except `bg-card` (PM's alias) -> `bg-surface-card`, the DS token the PA already uses for cards.
import { useInvoiceOrders } from '@/billing/services/use-invoice-orders';
import { groupOrderLines, hasAnyOrders } from '@/billing/lib/pending-orders';
import { formatMoney } from '@/shared/lib/money';

interface Props {
  invoiceId: string;
  currency: string;
}

/**
 * "Pending orders (indicative)" (canvas board 1, under the totals): the sum of
 * what is still pending, in its own dashed box so it is never read as part of
 * Patient Payable. The invoice totals box above it is unchanged. Reads the same
 * cached Orders query as the section, so it costs no extra request.
 */
export function InvoicePendingOrdersTotal({ invoiceId, currency }: Props) {
  const { data } = useInvoiceOrders(invoiceId);
  if (!hasAnyOrders(data)) return null;
  // Orders, not lines: a vaccine with an administration line is one order.
  const count = groupOrderLines(data.pending).length;
  return (
    <section
      aria-label="Pending orders (indicative)"
      data-billing="totals"
      className="rounded-lg border border-dashed border-border-strong bg-surface-card px-6 py-4"
    >
      <dl className="flex flex-col gap-1 text-sm">
        <div className="flex items-baseline justify-between gap-6">
          <dt className="text-text-secondary">Pending orders (indicative)</dt>
          <dd className="text-text-secondary tabular-nums">
            {currency} {formatMoney(data.pendingIndicativeTotal)}
          </dd>
        </div>
        <div className="text-xs text-text-muted tabular-nums">
          {count > 0
            ? `${count} order${count === 1 ? '' : 's'} · not included in Patient Payable`
            : 'No pending orders'}
        </div>
      </dl>
    </section>
  );
}
